import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_miezz_menu_tab = _resolveComponent("miezz-menu-tab")!
  const _component_miezz_page_list = _resolveComponent("miezz-page-list")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_miezz_form = _resolveComponent("miezz-form")!
  const _component_miezz_card = _resolveComponent("miezz-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_miezz_menu_tab, {
      modelValue: _ctx.menuTab,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.menuTab) = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(_component_miezz_card, {
      title: "编号规则",
      fix: true,
      fixTop: "30px",
      bottomButtons: _ctx.buttons,
      onHandleFooterButtonClick: _ctx.handleClick
    }, {
      default: _withCtx(() => [
        _createVNode(_component_miezz_form, {
          modelValue: _ctx.detail,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.detail) = $event))
        }, {
          "form-item": _withCtx(({ item }) => [
            (item.Prop == 'CodeRules')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: item.Label,
                  prop: item.Prop
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_miezz_page_list, {
                      modelValue: _ctx.list,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.list) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 2
                }, 1032, ["label", "prop"]))
              : _createCommentVNode("", true),
            (item.Prop == 'Remark')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 1,
                  label: item.Label,
                  prop: item.Prop
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Booking No.的编号规则为公司名称英文缩写+年份数字（2位）+月份（2位）+4位顺序数字，订单编号的规则为公司名称英文缩写+业务类型英文缩写+年份数字（2位）+月份（2位）+4位顺序数字；取消的委托书与订单的编号依然保留 ")
                  ]),
                  _: 2
                }, 1032, ["label", "prop"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["bottomButtons", "onHandleFooterButtonClick"])
  ], 64))
}